import type { SelectItem } from '@vrplatform/components';
import { parseAsString, useQueryStates } from '@vrplatform/query-params';
import { ensure, toTitleCase } from '@vrplatform/utils';
import type { StatementSummaryUnion } from '@vrplatform/ui-common';

export const useStatementSummaryState = () => {
  const [filter, setFilter] = useQueryStates({
    summary: parseAsString,
    startAt: parseAsString,
    endAt: parseAsString,
    summaryOwner: parseAsString,
    summaryVendor: parseAsString,
    summaryListing: parseAsString,
  });

  const setSummaryType = (v: StatementSummaryUnion) =>
    setFilter((s) => ({ ...s, summary: v }));

  return {
    filter,
    setFilter: (newState: any) =>
      setFilter((state) => ({ ...state, ...newState })),
    summaryType: (filter.summary ||
      'groupByReservation') as StatementSummaryUnion,
    setSummaryType,
    summaryOptions: (
      [
        'groupByListing',
        'groupByMonth',
        'groupByReservation',
        'groupByBookingChannel',
      ] as StatementSummaryUnion[]
    ).map((i) =>
      ensure<SelectItem>({
        label: toTitleCase(i?.replace('groupB', 'b')) || '',
        value: i,
      })
    ),
  };
};
